export { default as arrowLeft } from './arrowLeft.svg';
export { default as arrowRight } from './arrowRight.svg';
export { default as editIcon } from './editIcon.svg';
export { default as csvFailure } from './csvFailure.svg';